module.exports = __webpack_public_path__ + "static/media/AC.31178cce.svg";